import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";

import { lighten, useTheme } from "@mui/material";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";

import { createNewMotivation } from "../../data/omniDataModel";
import * as PatientSession from "../../state/redux/patientSession";
import { OmniStringToDate } from "../../utils/helpers";
import PatientMotivationDialog from "../dialogs/patientMotivationDialog";
import OmniResponsiveButton from "../ui/omniResponsiveButton.js";
import Widget from "../ui/widget";
import WidgetList from "../ui/widgetList";
import WidgetSkeleton from "../ui/widgetSkeleton";
import WidgetTextListItem from "../ui/widgetTextListItem.js";
import WidgetTitle from "../ui/widgetTitle";

const PatientMotivations = props => {
  const { motivationODMs, allowAdd = true } = props;

  const [selectedMotivation, setSelectedMotivation] = useState(null);

  const [titleText, setTitleText] = useState(null);

  useEffect(() => {
    if (motivationODMs != null) {
      setTitleText(`${motivationODMs.length} Motivation${motivationODMs.length === 1 ? "" : "s"}`);
    } else setTitleText("");
  }, [motivationODMs]);

  const theme = useTheme();

  return (
    <Widget>
      <WidgetTitle title={"Wellness"} text={titleText} loading={motivationODMs == null}>
        {allowAdd && (
          <OmniResponsiveButton
            tooltipTitle="Create a Motivation"
            buttonText="Motivation"
            onClick={() => {
              setSelectedMotivation(createNewMotivation);
            }}
          />
        )}
      </WidgetTitle>

      {motivationODMs == null && <WidgetSkeleton />}

      {motivationODMs != null && (
        <WidgetList>
          {motivationODMs
            .sort((a, b) => OmniStringToDate(b.date) - OmniStringToDate(a.date))
            .map((motivation, index) => {
              return (
                <WidgetTextListItem
                  key={`motivation${index}`}
                  onClick={() => {
                    setSelectedMotivation(motivation);
                  }}
                  sx={{
                    "&:hover": {
                      backgroundColor: lighten(theme.palette.secondary.main, 0.9),
                    },
                  }}
                >
                  <ListItemText
                    primary={
                      <div>
                        <Typography
                          variant="overline"
                          sx={{
                            webkitUserSelect: "none",
                            userSelect: "none",
                          }}
                        >
                          {motivation.omniData.title}
                        </Typography>
                      </div>
                    }
                    secondary={
                      <Typography
                        variant="h6"
                        sx={[
                          {
                            webkitUserSelect: "none",
                            userSelect: "none",
                          },
                          motivation.omniData.title && {
                            marginTop: `-${theme.spacing(1.5)}`,
                          },
                        ]}
                      >
                        {motivation.omniData.note}
                      </Typography>
                    }
                  />
                </WidgetTextListItem>
              );
            })}
        </WidgetList>
      )}

      {selectedMotivation != null && (
        <PatientMotivationDialog
          open={selectedMotivation != null}
          dialogTitle={`${selectedMotivation._id == null ? "Add" : "Edit"} Motivation`}
          motivationODM={selectedMotivation}
          textLabel={"Case Motivation"}
          onAccept={motivation => {
            // the returned note is a deepCopiedObject,
            props.updateMotivationRequest(motivation);
            setSelectedMotivation(null);
          }}
          onDelete={() => {
            props.deleteMotivationRequest(selectedMotivation._id);
            setSelectedMotivation(null);
          }}
          onClose={() => {
            setSelectedMotivation(null);
          }}
        />
      )}
    </Widget>
  );
};
const mapStateToProps = state => ({
  patientChart: state.patientSession.patientChart,
  motivationODMs: state.patientSession.patientMotivations,
});

const mapDispatchToProps = {
  loadMotivationODMRequest: PatientSession.loadMotivationODMRequest,
  updateMotivationRequest: PatientSession.updateMotivationRequest,
  deleteMotivationRequest: PatientSession.deleteMotivationRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(PatientMotivations);
